import { useState } from "react";
import { ExternalLink, MapPin, Search } from "lucide-react";

const hotels = [
  {
    name: "Go Guest House Lahore",
    type: "Guest House",
    city: "Lahore, Pakistan",
    description:
      "A comfortable guest house in Lahore offering well-furnished rooms and convenient access to the city.",
    image: "/portfolio/go-guest-house-lahore/cover.jpg",
    bookingUrl:
      "https://www.booking.com/hotel/pk/go-guest-house-lahore.html",
  },

  {
    name: "Second Home Family Hotel",
   type: "Hotel",
    city: "Lahore, Pakistan",
    description:
      "A family-friendly hotel in Johar Town, Lahore, offering comfortable rooms for short and extended stays.",
    image: "/portfolio/second-home-family-hotel/cover.jpg",
    bookingUrl:
      "https://www.booking.com/hotel/pk/second-home-family.html",
  },

  {
    name: "Waves Guest House Clifton KHI",
    type: "Guest House",
    city: "Karachi, Pakistan",
    description:
      "A luxury guest house in Clifton Block 4, near Dolmen Mall and the Chinese Consulate, with well-furnished rooms, an in-house kitchen and professional chef services.",
    image: "/portfolio/waves-guest-house-clifton-khi/cover.jpg",
    bookingUrl:
      "https://www.booking.com/hotel/pk/waves-guest-house-clifton-khi.html",
  },
];

export default function BookYourStay() {
  const [selectedCity, setSelectedCity] = useState("All Cities");
const [searchCity, setSearchCity] = useState("All Cities");
const [selectedType, setSelectedType] = useState("All Types");
const [searchType, setSearchType] = useState("All Types");
  const cities = ["All Cities", ...new Set(hotels.map((hotel) => hotel.city))];
const propertyTypes = [
  "All Types",
  "Hotel",
  "Guest House",
  "Resort",
  "Villa",
  "Serviced Apartment",
  "Apartment",
  "Holiday Home",
];
  const filteredHotels = hotels.filter((hotel) => {
  const cityMatches =
    searchCity === "All Cities" || hotel.city === searchCity;

  const typeMatches =
    searchType === "All Types" || hotel.type === searchType;

  return cityMatches && typeMatches;
});
  return (
    <main className="bg-white">
      <section className="bg-navy px-5 py-20 sm:px-8 lg:py-28">
        <div className="mx-auto max-w-7xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-sky">
            Book Your Stay
          </p>

          <h1 className="mt-4 font-serif text-4xl font-semibold text-white sm:text-5xl">
            Find Your Perfect Stay
          </h1>

          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-slate-300">
            Explore our selected hospitality properties and book your stay
            directly through Booking.com.
          </p>
        </div>
      </section>

      <section className="px-5 py-16 sm:px-8 lg:py-24">
  <div className="mx-auto max-w-7xl">

    <div className="mx-auto mb-12 max-w-3xl rounded-2xl border border-line bg-slate-50 p-6 shadow-sm">
      <div className="flex items-center gap-2">
        <Search className="h-5 w-5 text-ocean" />

        <h2 className="font-serif text-xl font-semibold text-navy">
          Find a Stay by City
        </h2>
      </div>

      <div className="mt-5 flex flex-col gap-3 sm:flex-row">
        <select
          value={selectedCity}
          onChange={(e) => setSelectedCity(e.target.value)}
          className="w-full rounded-full border border-line bg-white px-5 py-3 text-sm text-navy outline-none focus:border-ocean sm:flex-1"
        >
          {cities.map((city) => (
            <option key={city} value={city}>
              {city}
            </option>
          ))}
        </select>
        <select
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          className="w-full rounded-full border border-line bg-white px-5 py-3 text-sm text-navy outline-none focus:border-ocean sm:flex-1"
        >
          {propertyTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
       <button
  type="button"
 onClick={() => {
  setSearchCity(selectedCity);
  setSearchType(selectedType);
}}
  className="rounded-full bg-navy px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-ocean"
>
  Search
</button>
      </div>
    </div>
{filteredHotels.length === 0 && (
  <div className="mb-8 rounded-2xl border border-line bg-slate-50 px-6 py-10 text-center">
    <h2 className="font-serif text-2xl font-semibold text-navy">
      No properties found
    </h2>

    <p className="mt-2 text-sm text-slate-600">
      We don't currently have properties listed in this city.
    </p>
  </div>
)}
    <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {filteredHotels.map((hotel) => (
              <article
                key={hotel.name}
                className="group overflow-hidden rounded-2xl border border-line bg-white shadow-float transition-all duration-300 hover:-translate-y-2 hover:shadow-float-lg"
              >
                <div className="h-56 overflow-hidden">
                  <img
                    src={hotel.image}
                    alt={hotel.name}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>

                <div className="p-6">
                  <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-navy">
                    {hotel.type}
                  </span>

                  <h2 className="mt-4 font-serif text-2xl font-semibold text-navy">
                    {hotel.name}
                  </h2>

                  <p className="mt-2 flex items-center gap-2 text-sm text-slate-500">
                    <MapPin className="h-4 w-4 text-ocean" />
                    {hotel.city}
                  </p>

                  <p className="mt-4 text-sm leading-7 text-slate-600">
                    {hotel.description}
                  </p>

                  <a
                    href={hotel.bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-navy px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-ocean"
                  >
                    Book Your Stay
                    <ExternalLink className="h-4 w-4" />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
